import React, { useContext } from 'react'
import { array } from 'prop-types'

import Grid from '../../Grid'
import Card from '../../Card'
import Surround from '../../Surround'
import Hide from '../../Hide'
import Carousel from '../../Carousel'
import Tag from '../../Tag'
import { RowContext } from '@/component/Context/RowContext'
import styles from '../CardGrid.module.scss'

const CardGrid7 = ({ articles }) => {
  const inverseRow = useContext(RowContext)
  if (!articles.length) return null
  const imageRatio = 455 / 322
  const cardClassnames = {
    cardImage: {
      root: styles.CardImageRoot
    },
    cardContent: {
      root: styles.CardContentRoot,
      title: styles.Title,
      description: styles.Description
    }
  }
  return (
    <>
      <Hide below="desktop">
        <Grid flex gutter="default">
          {articles.map((article, i) => (
            <Grid.Item
              key={i}
              width={{ d: 1 / 3 }}
              trailingGap={i < articles.length - 3 ? 'default' : null}
            >
              <Surround padded="desktop" bordered="desktop">
                <Card
                  typeConfig={{
                    title: { size: 'heading7', weight: 'medium', themed: true }
                  }}
                  inverse={inverseRow}
                  {...{
                    ...article,
                    sizes: [
                      '(min-width: 1420px) 212px',
                      'calc(16.6666vw - 80px)'
                    ],
                    width: 212
                  }}
                  imageRatio={imageRatio}
                  className={styles.CardGrid7}
                  classNames={cardClassnames}
                  headerComponents={() => {
                    if (!article.featured) return null
                    return (
                      <Tag themedFont background="black">
                        Featured
                      </Tag>
                    )
                  }}
                />
              </Surround>
            </Grid.Item>
          ))}
        </Grid>
      </Hide>
      <Hide at="desktop">
        <Carousel>
          {articles.map((article, i) => (
            <div key={i}>
              <Card
                typeConfig={{
                  title: { size: 'heading7', weight: 'medium', themed: true }
                }}
                inverse={inverseRow}
                {...{ ...article, sizes: ['calc(75vw - 80px)'], width: 412 }}
                imageRatio={imageRatio}
                className={styles.CardGrid7}
                classNames={cardClassnames}
              />
            </div>
          ))}
        </Carousel>
      </Hide>
    </>
  )
}

CardGrid7.propTypes = {
  articles: array
}

export default CardGrid7
